import React from 'react';
import PageHeader from './components/PageHeader';
import { useAnimatedClose } from './hooks/useAnimatedClose';
import { formatImportDate } from './utils/formatDate';

export default function ViewImportDialog({ job, onClose }) {
  const { close, isClosing } = useAnimatedClose(onClose);
  if (!job) return null;
  const importedDate = formatImportDate(job.importedAt);
  const previewDate = importedDate || formatImportDate(job.started) || formatImportDate(job.finished) || '—';
  const facilityDetails = Array.isArray(job.facilityDetails) ? job.facilityDetails : [];
  const items = Array.isArray(job.packageDetails) && job.packageDetails.length > 0
    ? job.packageDetails
    : (Array.isArray(job.productDetails) ? job.productDetails : []);

  const title = job.type || 'Import Details';

  return (
    <div className={`stack page-slide-in${isClosing ? ' page-slide-out' : ''}`} data-testid="view-import">
      <PageHeader
        title={title}
        subtitle="Integrations"
        actions={(
          <button className="button secondary" onClick={close}>Back</button>
        )}
      />

      <div className="drawer-body">
        <div className="drawer-preview">
          <div className="card" style={{ padding: 16 }}>
            <div className="muted" style={{ fontSize: 12, fontWeight: 800, marginBottom: 8 }}>Preview</div>
            <div style={{ fontWeight: 800, fontSize: 16, marginBottom: 8 }}>{title}</div>
            <div className="muted" style={{ fontSize: 13, display: 'grid', gap: 6, marginBottom: 10 }}>
              <div><span style={{ fontWeight: 700, color: 'var(--primary)' }}>Date:</span> {previewDate}</div>
              <div><span style={{ fontWeight: 700, color: 'var(--primary)' }}>Facilities:</span> {facilityDetails.length}</div>
              <div><span style={{ fontWeight: 700, color: 'var(--primary)' }}>Items:</span> {items.length}</div>
            </div>
            <div className="divider" style={{ margin: '12px 0' }} />
            <div className="muted" style={{ fontSize: 12, fontWeight: 800, marginBottom: 8 }}>Highlights</div>
            <div style={{ display: 'grid', gap: 8 }}>
              {(facilityDetails || []).slice(0, 3).map((f) => (
                <div key={f.license} className="card" style={{ padding: 10 }}>
                  <div style={{ fontWeight: 800, fontSize: 13 }}>{f.name}</div>
                  <div className="muted" style={{ fontSize: 12 }}>{f.license}</div>
                </div>
              ))}
              {(items || []).slice(0, 3).map((p, idx) => (
                <div key={p.id || p.packageId || p.name || idx} className="card" style={{ padding: 10 }}>
                  <div style={{ fontWeight: 800, fontSize: 13 }}>{p.metrcName || p.productName || 'Item'}</div>
                  <div className="muted" style={{ fontSize: 12 }}>{p.label ? p.label : (p.license || p.facility || '—')}</div>
                </div>
              ))}
              {facilityDetails.length === 0 && items.length === 0 && (
                <div className="muted" style={{ fontSize: 12 }}>No details available.</div>
              )}
            </div>
          </div>
        </div>

        <div className="drawer-controls">
          <div className="drawer-controls-card">
            <div className="form-grid">
              <div className="field">
                <label className="label">Date</label>
                <div>{importedDate || '—'}</div>
              </div>
              <div className="field full-span">
                <label className="label">Facilities ({facilityDetails.length})</label>
                <div style={{ border: '1px solid var(--border)', borderRadius: 12, padding: 8, maxHeight: 200, overflowY: 'auto' }}>
                  {facilityDetails.length === 0 && <div className="muted">None</div>}
                  {facilityDetails.map((f) => (
                    <div key={f.license} style={{ padding: '6px 4px' }}>
                      <div style={{ fontWeight: 700 }}>{f.name}</div>
                      <div className="muted" style={{ fontSize: 12 }}>{f.license} · {f.org || 'Unassigned'}</div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="field full-span">
                <label className="label">Items ({items.length})</label>
                <div style={{ border: '1px solid var(--border)', borderRadius: 12, padding: 8, maxHeight: 200, overflowY: 'auto' }}>
                  {items.length === 0 && <div className="muted">None</div>}
                  {items.map((p, idx) => (
                    <div key={p.id || p.packageId || p.name || idx} style={{ padding: '6px 4px' }}>
                      <div style={{ fontWeight: 700 }}>{p.metrcName || p.productName || 'Item'}</div>
                      <div className="muted" style={{ fontSize: 12 }}>{p.label ? `${p.label} · ` : ''}{p.license || p.facility || '—'}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
